// src/components/list/FolderListItem.tsx

import { MemoryTwoTone } from '@mui/icons-material'
import {
  Avatar,
  Checkbox,
  Chip,
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material'

import {
  FolderId,
  FolderImage,
  FolderName,
  FolderShortName,
  SensorRecord,
} from '@/types/domain'

import {
  useFolderImage,
  useFolderName,
  useFolderSensors,
  useFolderShortName,
} from '../../hooks'

type Props = {
  id: FolderId
  onClick?: () => void
  selected?: boolean
}

export const FolderListItem = ({ id, onClick, selected }: Props) => {
  const fName: FolderName = useFolderName(id)
  const fShort: FolderShortName = useFolderShortName(id)
  const fImage: FolderImage = useFolderImage(id)
  const fSensors: SensorRecord[] = useFolderSensors(id)
  const fsCount: number = fSensors?.length

  return (
    <ListItem>
      <ListItemButton selected={selected} onClick={onClick}>
        <ListItemAvatar>
          <Avatar src={fImage} />
        </ListItemAvatar>

        <ListItemText primary={fName} secondary={fShort} sx={{ width: 0.5 }} />

        <ListItemText
          primary={
            <Chip
              icon={<MemoryTwoTone />}
              label={fsCount}
              color={fsCount > 0 ? 'default' : 'warning'}
            />
          }
          sx={{ width: 0.5 }}
        />

        <ListItemIcon>
          <Checkbox checked={selected} />
        </ListItemIcon>
      </ListItemButton>
    </ListItem>
  )
}
